"use strict";

angular.module("core")
.component("selectionCount", {
    templateUrl: require("./selection-count.component.html"),
    bindings: {
        selectedCount: "<",
        totalCount: "<"
    },
    controllerAs: "selectionCountCtrl",
    controller: function($scope) {
        this.clearSelection = function() {
            $scope.$emit("clearSelection");
        }
    }
});



//////////////////
// WEBPACK FOOTER
// ./core/selection-count/selection-count.component.js
// module id = 588
// module chunks = 0